// src/pages/ServiceManagement/ServiceList.jsx
import React from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
  Typography,
  InputAdornment,
  Avatar
} from '@mui/material';
import {
  Search as SearchIcon,
  Apps as AppsIcon
} from '@mui/icons-material';

const ServiceList = ({ services, selectedService, onSelectService, searchTerm, onSearchChange }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Search */}
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Search services..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            )
          }}
        />
      </Box>

      {/* Service List */}
      <List sx={{ flex: 1, overflow: 'auto', p: 0 }}>
        {services.length === 0 ? (
          <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              No services found
            </Typography>
          </Box>
        ) : (
          services.map((service) => (
            <ListItem key={service.id} disablePadding>
              <ListItemButton
                selected={selectedService?.id === service.id}
                onClick={() => onSelectService(service)}
                sx={{
                  borderLeft: 3,
                  borderColor: selectedService?.id === service.id ? 'primary.main' : 'transparent'
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                  <Avatar
                    src={service.logo}
                    sx={{ width: 40, height: 40 }}
                  >
                    <AppsIcon />
                  </Avatar>
                  <ListItemText
                    primary={
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: selectedService?.id === service.id ? 600 : 400
                        }}
                      >
                        {service.friendlyName || service.name}
                      </Typography>
                    }
                    secondary={
                      <Box sx={{ mt: 0.5 }}>
                        <Typography variant="caption" color="text.secondary" display="block">
                          {service.description || 'No description'}
                        </Typography>
                      </Box>
                    }
                  />
                </Box>
              </ListItemButton>
            </ListItem>
          ))
        )}
      </List>
    </Box>
  );
};

export default ServiceList;
